import { Injectable } from '@angular/core';

import { Fibre } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class FibreService extends TmsWebBaseEditService<Fibre, Fibre> {
  constructor() {
    super('Fibre', $localize`Fibre`);
  }
}
